import React from 'react';
import styled from 'styled-components';

const PlaceholderContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 100%;
  background: linear-gradient(180deg, #f9fbff 0%, #f5f8fd 100%);
  color: #455776;
  text-align: center;
  padding: 40px 20px;
  
  @media (max-width: 768px) {
    padding: 20px 15px;
  }
`;

const PlaceholderIcon = styled.div`
  width: 100px;
  height: 100px;
  border-radius: 20px;
  background: linear-gradient(135deg, rgba(51, 92, 244, 0.25), rgba(51, 92, 244, 0.15));
  border: 2px solid rgba(51, 92, 244, 0.4);
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 35px;
  box-shadow: 0 8px 32px rgba(51, 92, 244, 0.15);
  backdrop-filter: blur(10px);
  
  &::before {
    content: ${props => props.tabName === 'WhiteBoard' ? '"📝"' : '"⚙️"'};
    font-size: 36px;
  }
  
  @media (max-width: 768px) {
    width: 80px;
    height: 80px;
    margin-bottom: 25px;
    border-radius: 16px;
    
    &::before {
      font-size: 28px;
    }
  }
`;

const PlaceholderTitle = styled.h2`
  color: #192947;
  font-size: 24px;
  font-weight: 500;
  margin-bottom: 15px;
  margin-top: 0;
  
  @media (max-width: 768px) {
    font-size: 20px;
    margin-bottom: 10px;
  }
`;

const PlaceholderDescription = styled.p`
  color: #65748d;
  font-size: 16px;
  line-height: 1.5;
  max-width: 400px;
  margin: 0 0 30px 0;
  
  @media (max-width: 768px) {
    font-size: 14px;
    margin-bottom: 20px;
  }
`;

const ComingSoonBadge = styled.div`
  background: linear-gradient(135deg, rgba(51, 92, 244, 0.2), rgba(51, 92, 244, 0.3));
  border: 1px solid rgba(51, 92, 244, 0.5);
  color: #335cf4;
  padding: 10px 20px;
  border-radius: 25px;
  font-size: 13px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.8px;
  box-shadow: 0 4px 15px rgba(51, 92, 244, 0.2);
  backdrop-filter: blur(10px);
  
  @media (max-width: 768px) {
    padding: 8px 16px;
    font-size: 12px;
  }
`;

const FeatureList = styled.div`
  margin-top: 30px;
  text-align: left;
  
  @media (max-width: 768px) {
    margin-top: 20px;
  }
`;

const FeatureItem = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 12px;
  color: #7b8aa3;
  font-size: 14px;
  
  &::before {
    content: "→";
    margin-right: 10px;
    color: rgba(51, 92, 244, 0.6);
  }
  
  @media (max-width: 768px) {
    font-size: 13px;
    margin-bottom: 10px;
  }
`;

const PlaceholderTab = ({ tabName, description }) => {
  const getFeatures = (tabName) => {
    switch (tabName) {
      case 'Feature 2':
        return [
          'Advanced analytics dashboard',
          'Real-time data visualization',
          'Custom reporting tools',
          'Performance metrics'
        ];
      case 'WhiteBoard':
        return [
          'Real-time collaborative drawing',
          'Multi-user whiteboard sessions',
          'Drawing tools and shapes',
          'Share and save whiteboard content'
        ];
      default:
        return [
          'Exciting new functionality',
          'Enhanced user experience',
          'Advanced capabilities',
          'Improved workflow'
        ];
    }
  };

  return (
    <PlaceholderContainer>
      <PlaceholderIcon tabName={tabName} />
      <PlaceholderTitle>{tabName}</PlaceholderTitle>
      <PlaceholderDescription>{description}</PlaceholderDescription>
      <ComingSoonBadge>Coming Soon</ComingSoonBadge>
      
      <FeatureList>
        {getFeatures(tabName).map((feature, index) => (
          <FeatureItem key={index}>{feature}</FeatureItem>
        ))}
      </FeatureList>
    </PlaceholderContainer>
  );
};

export default PlaceholderTab; 